import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseService} from './base.service';
import {Observable} from 'rxjs';
import {AlertService} from './alert.service';
import {GlobalService} from './global.service';
import {AppUrl} from '../constants/app-url';
import {UploadService} from './upload.service';

@Injectable({
    providedIn: 'root'
})

export class UniversityService extends BaseService {
    constructor(public http: HttpClient,
                public alertService: AlertService,
                public globalService: GlobalService,
                public fileUploadService: UploadService) {
        super(http, alertService, globalService);
    }

    get(data): Observable<any> {
        return this.getRequestWithoutErrorMessage(AppUrl.UNIVERSITIES(), data);
    }

    count(): Observable<any> {
        return this.getRequest(AppUrl.UNIVERSITIES_COUNT());
    }

    detail(id): Observable<any> {
        return this.getRequestWithoutErrorMessage(AppUrl.UNIVERSITIES(id));
    }

    detailByPCBMapping(id): Observable<any> {
        return this.getRequestWithoutErrorMessage(AppUrl.UNIVERSITY_BY_PCB_MAPPING(id));
    }

    create(data): Observable<any> {
        return this.postRequest(AppUrl.UNIVERSITIES(), data);
    }

    update(id, data): Observable<any> {
        return this.putRequest(AppUrl.UNIVERSITIES(id), data);
    }

    delete(id): Observable<any> {
        return this.deleteRequest(AppUrl.UNIVERSITIES(id));
    }

    updateProfile(id, data): Observable<any> {
        return this.putRequest(AppUrl.UNIVERSITIES_PROFILE_IMAGE(id), data);
    }

    updatePassword(id, data): Observable<any> {
        return this.putRequest(AppUrl.UNIVERSITIES_PASSWORD(id), data);
    }

    updateCampusVideoUrl(id, data): Observable<any> {
        return this.putRequest(AppUrl.UNIVERSITIES_CAMPUS_VIDEO(id), data);
    }

    updateStatus(id, data): Observable<any> {
        return this.putRequest(AppUrl.UNIVERSITIES_STATUS(id), data);
    }

    updateIsPopular(id, data): Observable<any> {
        return this.putRequest(AppUrl.UNIVERSITIES_IS_POPULAR(id), data);
    }

    updateTiedUp(id, data): Observable<any> {
        return this.putRequest(AppUrl.UNIVERSITIES_TIED_UP(id), data);
    }

    updatePartner(id, data): Observable<any> {
        return this.putRequest(AppUrl.UNIVERSITIES_PARTNER(id), data);
    }

    detailByLanding(id): Observable<any> {
        return this.getRequest(AppUrl.UNIVERSITIES_LANDING(id));
    }

    fileUploadAdmin(params, event): Observable<any> {
        return this.fileUploadService.fileUpload(AppUrl.FILE_UPLOAD_ADMIN(), params, event);
    }

    fileUpload(params, event): Observable<any> {
        return this.fileUploadService.fileUpload(AppUrl.FILE_UPLOAD(), params, event);
    }
}
